import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//按需加载elelement组件
import './ui/index'
import './styles/table-dark.css'
import './styles/pagination-dark.css'
import './styles/list-page-layout.css'
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

